import { RessortCategoryEntry } from '../helper/interfaces'
import React, { useState, useEffect } from 'react'
import { CheckSquare, ChevronDown, ChevronUp, PlusSquare } from 'react-feather';
import { AppContext } from '../provider/AppContextProvider';
import { ErrorText } from './shared/FeedbackText';

declare global {
  interface Window {
    frcaptcha: any;
  }
}

interface Data {
  categories: RessortCategoryEntry[]
}

function RessortCategoryComponent(data: Data) {
  const [checkedList, setCheckedList] = useState<string[]>([])
  const categories = data.categories || []
  const [email, setEmail] = useState<string>("")
  const [error, setError] = useState<string>("")
  const [processing, setProcessing] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [collapsed, setCollapsed] = useState<boolean>(false)

  const { headerDisabled } = React.useContext(AppContext);
  
  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const clickRegister = async () => {
    if(processing) {
      return
    }
    if(email.length > 0) {
      //validate email
      if(!isValidEmail(email)) {
        setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.')
        return
      }
      else {
        setProcessing(true)
        setError('')
        setSuccess(false)
        const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/piano-esp/subscribe`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: email, mlids: checkedList })
        });
        const result = await response.json();
        if(response.status === 200) {
          setSuccess(true)
          setProcessing(false)
        }
        else {
          setError(result.error || 'Fehler beim Abonnieren des Newsletters.')
          setProcessing(false)
        }

        //scroll to top of page
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    else {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.')
    }
  }

  const getCheckedListNames = () => {
    let names: string[] = []
    checkedList.forEach((id) => {
      categories.forEach((category) => {
        category.entries.forEach((mainEntry) => {
          mainEntry.entries.forEach((subEntry) => {
            if(subEntry.confirmationListId === id) {
              names.push(subEntry.name)
            }
          })
        })
      })
      return names.join(', ')
    })
    return names;
  }


  return (
    <React.Fragment>
      {success && (
        <div className="newsletter-success">
          <h2 className="newsletter-success__headline">Vielen Dank!</h2>
          <p className="newsletter-success__description">
            Wir freuen uns, dass Sie sich für <span id="checked_newsletter_multi">die Newsletter</span> 
            <span id="checked_newsletter">
              {getCheckedListNames().length > 0 && (
                <>
                  <> </>
                  {getCheckedListNames().map((name, index) => {
                    return (
                      <React.Fragment key={index}>
                        <strong>{name}</strong>
                        {index < getCheckedListNames().length - 2 && (
                          <>{", "}</>
                        )}
                        {index === getCheckedListNames().length - 2 && (
                          <>{" und "}</>
                        )}
                      </React.Fragment>
                    )
                  })}
                </>
              )}
            </span> interessieren.
          </p>
          <p className="newsletter-success__description" id="info_success">
            <span id="newsletter_success"></span>Jetzt fehlt nur noch ein kleiner Schritt: <strong>Aus Sicherheitsgründen bitten wir Sie, Ihre Anmeldung zum Newsletter zu bestätigen.</strong> So gehen wir sicher, dass Sie sich selbst angemeldet haben und schließen einen Missbrauch durch Dritte aus.
          </p>
          <p className="newsletter-success__description" id="info_success2">In Ihrem E-Mail-Postfach finden Sie eine E-Mail (an: <u id="send_email">{email}</u>) von uns mit einem Link, den Sie am besten sofort mit einem Klick bestätigen. Bitte sehen Sie in Ihrem Spam-Ordner nach, falls Sie in Ihrem Posteingang keine Bestätigungsmail finden. Sollten Sie gar nichts von uns erhalten, melden Sie sich bitte am besten kurz per E-Mail bei uns: <a href="mailto:newsletter@vnp.de" className="newsletter-success__description-link">newsletter@vnp.de</a>
          </p>

        </div>
      )}
      { categories.length > 0 && !success && 
        <div className="newsletter">

          {checkedList.length > 0 && 
            <div className="newsletter-register">
              <div className="newsletter-register__content">
                <div className="w-full">
                  {error && (
                    <ErrorText className="mb-1" role="alert">{error}</ErrorText>
                  )}
                  <div className="">
                      <input className="input" id="email" required placeholder="E-Mail" aria-label="E-Mail" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                  </div>
                  <button id="newsletter_submit_button" disabled={processing} className="btn btn-primary newsletter-register__submit" type="button" value="Abonnieren" onClick={clickRegister}>Abonnieren</button>
                </div>
              
                <div className={`newsletter-register__details ${collapsed ? 'newsletter-register__details--collapsed' : ''}`}>
                  <div className="newsletter-register__description">
                      Mit der Bestellung des Newsletters willigen Sie ein, dass wir Ihre Daten verarbeiten sowie Ihr Nutzungsverhalten analysieren, um die Gestaltung künftiger Newsletter zu verbessern. Weitere Informationen gem. Art. 13 DSGVO und zum Widerruf finden Sie in unserer <a href={`${process.env.NEXT_PUBLIC_VNP_BASE_URL}/datenschutz`} target="_blank" rel="noopener noreferrer" className="newsletter-register__description-link">Datenschutzerklärung.</a><br />
                      Haben Sie Fragen? Dann kontaktieren Sie uns gerne unter: <a href="mailto:newsletter@vnp.de" className="newsletter-register__description-link">newsletter@vnp.de</a>
                    </div>
                </div>
                <button className="newsletter-register__toggle" onClick={() => setCollapsed(!collapsed)}>{collapsed ? <ChevronDown /> : <ChevronUp />}</button>
              </div>
            </div>      
          }

          <h2 className="newsletter__headline">Melden Sie sich für die Newsletter Ihrer Wahl an!</h2>

          <div className={`newsletter-list ${checkedList.length > 0 ? 'mt-4' : ''}`}>
            { categories.map((category) => {
              return (
                <React.Fragment key={`category-${category.externalId}`}>
                  <div className="newsletter-category">
                    {/* <div className="newsletter_category"> { category.name }</div> */}
                    { category.entries && category.entries.length > 0 && 
                      <>
                        { category.entries.map((mainEntry, index) => {
                          return (
                            <div className="newsletter-main-entry" key={`category_${index}_mainEntry_${mainEntry.externalId}`}>
                              <h3 className="newsletter-main-entry__name"> { mainEntry.name }</h3>
                              {mainEntry.entries && mainEntry.entries.length > 0 && 
                                <div className="newsletter-sub-entries">
                                  { mainEntry.entries.map((subEntry, index) => {
                                    return (
                                      <button className="newsletter-sub-entry" key={`mainEntry_${index}_subEntry_${subEntry.externalId}`} onClick={checkedList.includes(subEntry.confirmationListId) ? () => setCheckedList(checkedList.filter((id) => id !== subEntry.confirmationListId)) : () => setCheckedList([...checkedList, subEntry.confirmationListId])}>
                                        <h4 className="newsletter-sub-entry__name"> { subEntry.name }</h4>
                                        <div className="newsletter-sub-entry__footer">
                                          <div className="newsletter-sub-entry__info">{ subEntry.publicationMode }</div>
                                          {checkedList.includes(subEntry.confirmationListId) ? (
                                            <span className="newsletter-sub-entry__active">
                                              <CheckSquare />
                                            </span>
                                          ) : (
                                            <span className="newsletter-sub-entry__add">
                                              <PlusSquare />
                                            </span>
                                          )}
                                        </div>
                                      </button>
                                    )
                                  })}
                                </div>
                              }
                            </div>
                          )
                        })}
                      </>
                    }
                  </div>
                </React.Fragment>
              )
            })}
          </div>
        </div>
      }
    </React.Fragment>
  )
}

export default RessortCategoryComponent